import type { GameModule } from '../core/GameModule';
import type { Engine } from '../core/Engine';
import { fontMd, radius } from './UITheme';

/**
 * Persistenter Button unten-links auf dem Hauptscreen.
 * Öffnet das Reise-Menü per Event.
 */
export class TravelButton implements GameModule {
  readonly name = 'TravelButton';

  private _engine!: Engine;
  private _root: HTMLButtonElement | null = null;

  init(engine: Engine): void {
    this._engine = engine;
    this._buildDOM();

    // Verstecken wenn PlanetHub oder TravelMenu offen
    engine.events.on<null>('planet:hub-opened', () => this._setHidden(true));
    engine.events.on<null>('planet:hub-closed', () => this._setHidden(false));
    engine.events.on<null>('travel:open-menu', () => this._setHidden(true));
    engine.events.on<null>('travel:menu-closed', () => this._setHidden(false));
  }

  update(_dt: number): void { /* noop */ }

  dispose(): void {
    this._root?.remove();
    this._root = null;
  }

  private _buildDOM(): void {
    const btn = document.createElement('button');
    this._root = btn;

    Object.assign(btn.style, {
      position: 'fixed',
      bottom: 'clamp(16px, 3vw, 24px)',
      right: 'clamp(12px, 2vw, 20px)',
      zIndex: '6000',
      width: 'clamp(44px, 8vw, 56px)',
      height: 'clamp(44px, 8vw, 56px)',
      borderRadius: radius(),
      border: '1px solid rgba(136,204,255,0.3)',
      background: 'rgba(10,18,35,0.85)',
      color: '#8cf',
      fontSize: fontMd(),
      fontFamily: 'monospace',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 0 12px rgba(100,180,255,0.1), inset 0 1px 0 rgba(100,180,255,0.08)',
      transition: 'transform 150ms ease, box-shadow 150ms ease, opacity 200ms ease',
      backdropFilter: 'blur(4px)',
    });

    btn.textContent = '\u{1F680}';
    btn.title = 'Flottenreise';

    btn.addEventListener('pointerenter', () => {
      Object.assign(btn.style, {
        transform: 'scale(1.08)',
        boxShadow: '0 0 20px rgba(100,180,255,0.25), inset 0 1px 0 rgba(100,180,255,0.15)',
        borderColor: 'rgba(136,204,255,0.6)',
      });
    });
    btn.addEventListener('pointerleave', () => {
      Object.assign(btn.style, {
        transform: 'scale(1)',
        boxShadow: '0 0 12px rgba(100,180,255,0.1), inset 0 1px 0 rgba(100,180,255,0.08)',
        borderColor: 'rgba(136,204,255,0.3)',
      });
    });
    btn.addEventListener('pointerdown', (e) => {
      e.stopPropagation();
      this._engine.events.emit('travel:open-menu', null);
    });

    document.body.appendChild(btn);
  }

  private _setHidden(hidden: boolean): void {
    if (this._root) {
      this._root.style.opacity = hidden ? '0' : '1';
      this._root.style.pointerEvents = hidden ? 'none' : 'auto';
    }
  }
}
